<template>
  <div :class="`dropdown-categories-block ${isShowFilterBlock ? 'show' : ''}`">
    <div class="dropdown-header-block">
      <p class="dropdown-header-title">{{ title }}</p>
      <button
        class="create-bayment-close-button"
        @click.stop="$emit('on-backdrop-click')"
      >
        <x-icon class="create-payment-close-icon" />
      </button>
    </div>
    <div class="period-inputs-container">
      <div class="period-block">
        <p class="period-block-key">{{ $t("analytics.from") }}</p>
        <p class="period-block-value">{{ activeDateFrom }}</p>
      </div>
      <div class="period-block">
        <p class="period-block-key">{{ $t("analytics.to") }}</p>
        <p class="period-block-value">{{ activeDateTo }}</p>
      </div>
    </div>
    <vue-perfect-scrollbar class="list-scroll-area">
      <div
        v-for="item of list"
        :key="item.id"
        :class="[
          `categories-item ${activeValue.id === item.id ? 'active' : ''}`,
        ]"
        @click.stop="setCheckElement(item)"
      >
        <p class="categories-item-text">{{ item.value }}</p>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import { XIcon } from "vue-feather-icons";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { getMonthFirstAndLastDay } from "../../helpers/utils";

export default {
  name: "fixed-bottom-filter-block",
  components: {
    XIcon,
    // QuestionMarkIcon,
    VuePerfectScrollbar,
  },
  props: {
    title: {
      type: String,
      require: true,
    },
    isShowFilterBlock: {
      type: Boolean,
      require: true,
    },
    list: {
      type: Array,
      require: false,
    },
  },
  data() {
    return {
      activeValue: { id: 0 },
      activeDateFrom: getMonthFirstAndLastDay().firstDay,
      activeDateTo: getMonthFirstAndLastDay().lastDay,
    };
  },
  async mounted() {},

  methods: {
    isOpenSettingsPage() {
      this.$emit("set-is-open-fixed-list");
      this.$emit("set-is-open-settings-category");
    },
    setCheckElement(value) {
      this.activeValue = value;
      (this.activeDateFrom = getMonthFirstAndLastDay(value.date).firstDay),
        (this.activeDateTo = getMonthFirstAndLastDay(value.date).lastDay);
      let currentType = this.typeOperations.find(
        (el) => el.slug === this.activeAnalyticType
      );
      this.$emit("let-filter-analytics", value, currentType.id);
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  },
  computed: {
    activeAnalyticType() {
      return this.$store.getters.activeAnalyticType;
    },
    typeOperations() {
      return this.$store.getters.typeOperations;
    },
  },
  watch: {},
};
</script>

<style scoped>
.dropdown-categories-block {
  position: fixed;
  width: 100%;
  z-index: 1000000000;
  height: 80vh;
  left: 0px;
  bottom: 0px;
  background: #e8e8e8;
  transform: translateY(100%);
  transition: all 0.5s ease;
  border: 1px solid rgba(0, 0, 0, 0.07);
}

.dropdown-categories-block.show {
  transform: translateY(0);
}

.categories-item {
  display: flex;
  gap: 15px;
  background: transparent;
  padding: 5px 20px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.categories-item-text {
  font-weight: 400;
  line-height: 40px;
  font-size: 15px;
  font-family: "Source Sans 3", sans-serif;
  color: #212529;
  transition: all 0.25s ease;
}

.categories-item:hover {
  background-image: var(--main-bg-color);
  color: #fff;
}

.categories-item:hover p {
  color: #fff;
}

.categories-item.active {
  background-image: var(--main-bg-color);
  color: #fff;
}

.categories-item.active p {
  color: #fff;
}

.dropdown-header-block {
  display: flex;
  padding: 15px 10px;
  /* border-bottom: 2px solid rgba(0, 0, 0, 0.07); */
}

.dropdown-header-title {
  font-size: 18px;
  line-height: 25px;
  font-weight: 700;
  color: #1b1b1b;
  font-family: "Source Sans Pro", sans-serif;
  letter-spacing: -0.6px;
  margin-bottom: 0px;
}

.list-scroll-area {
  max-height: 70vh;
  width: 100%;
  padding-bottom: 20px;
}

@media (max-height: 500px) {
  .list-scroll-area {
    padding-bottom: 40px;
  }
}

.create-bayment-close-button {
  cursor: pointer;
  background: transparent;
  border: none;
  margin-left: auto;
}

.create-payment-close-icon {
  width: 26px;
  height: 26px;
  color: #d84558;
}

.period-inputs-container {
  display: flex;
  width: 100%;
  gap: 10px;
  justify-content: center;
}

.period-block {
  position: relative;
  padding: 11px 10px;
  border: 1px rgba(0, 0, 0, 0.07) solid !important;
  border-radius: 10px;
  background: #e8e8e8;
  height: 53px;
  width: 45%;
}

.period-block-key {
  font-weight: 600;
  line-height: 13px;
  font-size: 12px;
  font-family: "Source Sans 3", sans-serif;
  color: #929293;
  font-size: 13px;
}

.period-block-value {
  font-size: 13px;
  font-weight: 600;
  line-height: 25px;
  font-size: 12px;
  font-family: "Source Sans 3", sans-serif;
  font-size: 13px;
  color: #0e1216;
}
</style>
